import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "indicator"]

  initialize() {
    this.currentIndex = 0
  }

  go(event) {
    event.preventDefault()
    event.stopPropagation()
    this.show(parseInt(event.currentTarget.dataset.index, 10))
  }

  prev(event) {
    event.preventDefault()
    event.stopPropagation()
    const total = this.slideTargets.length
    this.show((this.currentIndex - 1 + total) % total)
  }

  next(event) {
    event.preventDefault()
    event.stopPropagation()
    const total = this.slideTargets.length
    this.show((this.currentIndex + 1) % total)
  }

  show(index) {
    this.currentIndex = index

    this.slideTargets.forEach((slide, i) => {
      slide.classList.toggle("opacity-100", i === index)
      slide.classList.toggle("opacity-0", i !== index)
    })

    this.indicatorTargets.forEach((dot, i) => {
      const active = i === index
      dot.classList.toggle("w-2", active)
      dot.classList.toggle("h-2", active)
      dot.classList.toggle("bg-white", active)
      dot.classList.toggle("w-1.5", !active)
      dot.classList.toggle("h-1.5", !active)
      dot.classList.toggle("bg-white/60", !active)
    })
  }
}
